
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { messageDirectionItems } from '../../../constants/messageDirection';

export default class MessagesPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.controller = 'messages';
        this.entity = 'message';
        this.title = 'messages';
        this.searchFields = ['uuid'];

        this.cells = [
            {
                cell: 'Text',
                id: 'uuid',
                label: 'uuid',
                alignRight: false,
                disableEditor: true,
                displayGrid: true
            },
            {
                cell: 'Number',
                id: 'userId',
                label: 'userId',
                alignRight: true,
                disableEditor: false,
                displayGrid: true
            },
            {
                cell: 'Items',
                id: 'direction',
                label: 'direction',
                alignRight: false,
                disableEditor: false,
                displayGrid: true,
                items: messageDirectionItems
            },
            {
                cell: 'BigText',
                id: 'text',
                label: 'text',
                alignRight: false,
                disableEditor: false,
                displayGrid: true
            },
            {
                cell: 'CreateModify',
                id: 'createdModified',
                label: 'dateCreatedModified',
                alignRight: false,
                disableEditor: true,
                displayGrid: true,
                displayDialogDetails: true,
                details: 'Json',
                elements: ['dateCreated', 'dateModified'],
                customSort: 'dateCreated'
            }
        ];
    }
}

